<template>
  <div
    class="d-flex justify-content-between px-2 py-1 configuration__line custom-hover"
    @click="selectConfiguration"
  >
    <div>
      <div class="header">{{ dataItem.nodeName }}</div>
      <div class="sub-header">{{ dataItem.ipAddress }}</div>
      <div>
        <b-badge
          pill
          variant="light-primary"
          class="badge--width custom-badge-margin-top text--small-size"
          >{{ dataItem.version }}</b-badge
        >
      </div>
    </div>

    <div>
      <div class="header">{{ dataItem.date }}</div>
      <div class="sub-header text-right">{{ dataItem.time }}</div>
    </div>
  </div>
</template>

<script>
import { BBadge } from "bootstrap-vue"

export default {
  name: "MoleculeDashboardConfigurationItem",
  components: {
    BBadge,
  },
  props: {
    dataItem: {
      type: Object,
      required: true,
    },
  },
  emits:["onClickCompareConfiguration"],
  methods: {
    selectConfiguration() {
      const nodeId = this.dataItem.id
      const version = this.dataItem.version.replace(/\D/g,'')
      this.$emit("onClickCompareConfiguration", nodeId, version)
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-hover:hover {
  cursor: pointer;
  background-color: #f6f6f9;
}

.configuration__line {
  border-bottom: 1px solid #ebe9f1;
}

.header {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #6e6b7b;

  overflow-wrap: break-word;
  word-break: break-word;
}

.sub-header {
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
}

.custom-badge-margin-top {
  margin-top: 8px;
}

.text--small-size {
  font-size: 10px;
}
</style>
